import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHelmet from '@/components/base/SEOHelmet';
import { Link } from 'react-router-dom';
import { useRef } from 'react';

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于番木瓜漫画',
  description: '番木瓜漫画免费全集阅读平台，提供海量热门漫画免费在线阅读。了解番木瓜漫画的品牌故事、口碑评价和联系方式。',
  url: 'https://www.fanmugua.com/about',
  isPartOf: {
    '@type': 'WebSite',
    name: '番木瓜漫画',
    url: 'https://www.fanmugua.com',
  },
  about: {
    '@type': 'Organization',
    name: '番木瓜漫画',
    description: '番木瓜漫画是一个提供海量免费漫画全集阅读的中文漫画平台，覆盖热血、恋爱、玄幻、搞笑等多种漫画类型。',
    url: 'https://www.fanmugua.com',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@fanmugua.com',
      availableLanguage: ['Chinese'],
    },
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '番木瓜漫画是否真的免费？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的！番木瓜漫画所有漫画内容均免费提供，无需付费，无需会员，在线即可免费阅读全部漫画全集。番木瓜漫画网致力于为广大漫画爱好者提供优质的免费阅读体验。',
      },
    },
    {
      '@type': 'Question',
      name: '番木瓜漫画支持什么阅读方式？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '番木瓜漫画支持下拉式阅读，无需翻页，流畅滚动即可畅快阅读。同时支持PC端和移动端，随时随地享受番木瓜漫画免费全集的阅读乐趣。',
      },
    },
    {
      '@type': 'Question',
      name: '番木瓜漫画有多少部作品？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '番木瓜漫画网收录了海量热门漫画，涵盖热血、恋爱、玄幻、搞笑、悬疑、科幻、都市、古风等多种类型。番木瓜漫画持续更新中，每日都有新内容上线。',
      },
    },
    {
      '@type': 'Question',
      name: '番木瓜漫画的更新频率如何？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '番木瓜漫画每日更新，保持高频次的漫画更新节奏。热门连载漫画第一时间同步更新，确保读者能够及时追更。番木瓜漫画网始终与各大漫画平台保持同步。',
      },
    },
    {
      '@type': 'Question',
      name: '如何在番木瓜漫画上找到想看的作品？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '番木瓜漫画提供完善的分类系统，您可以通过分类导航快速找到喜欢的漫画类型。同时番木瓜漫画网首页展示了热门推荐和最新更新，方便您发现精彩作品。',
      },
    },
  ],
};

const testimonials = [
  {
    name: '小明',
    avatar: 'ri-user-star-line',
    role: '资深漫迷',
    content: '番木瓜漫画真的太好用了！免费全集随便看，更新速度也很快。下拉式阅读体验超赞，比翻页舒服多了。番木瓜漫画网已经成了我每天必刷的网站！',
    rating: 5,
  },
  {
    name: '小华',
    avatar: 'ri-user-heart-line',
    role: '漫画爱好者',
    content: '分类很全，想看的漫画基本都能在番木瓜漫画找到。界面清爽，没有乱七八糟的广告，阅读体验很棒。番木瓜漫画免费阅读真的良心！',
    rating: 5,
  },
  {
    name: '小红',
    avatar: 'ri-user-smile-line',
    role: '二次元达人',
    content: '番木瓜漫画的漫画库太丰富了，很多小众漫画都有收录。最喜欢的是下拉式阅读方式，一口气能看几百话不费劲。番木瓜漫画网强烈推荐！',
    rating: 5,
  },
  {
    name: '小刚',
    avatar: 'ri-user-voice-line',
    role: '追更一族',
    content: '更新速度没得说，热门漫画基本都是同步更新。番木瓜漫画免费全集这个定位真的很良心，不用花钱就能看所有漫画，宅家看番木瓜漫画简直不要太爽！',
    rating: 4,
  },
  {
    name: '小李',
    avatar: 'ri-emotion-happy-line',
    role: '学生党漫迷',
    content: '作为学生党，番木瓜漫画完全免费真的太友好了。不用省零花钱买漫画，在番木瓜漫画网上就能免费畅读。番木瓜漫画的漫画大全真的很全！',
    rating: 5,
  },
  {
    name: '大勇',
    avatar: 'ri-user-received-line',
    role: '上班族漫迷',
    content: '通勤路上用手机看番木瓜漫画特别方便，下拉式阅读单手就能操作。番木瓜漫画的加载速度也很快，不卡顿，体验满分。番木瓜漫画网yyds！',
    rating: 5,
  },
];

export default function AboutPage() {
  const contactRef = useRef<HTMLDivElement>(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <SEOHelmet
        title="关于番木瓜漫画 - 免费漫画全集阅读平台 | 番木瓜漫画网"
        description="了解番木瓜漫画的品牌故事、发展历程和口碑评价。番木瓜漫画是一个提供海量免费漫画全集阅读的中文漫画平台，支持下拉式在线阅读。番木瓜漫画网联系方式和常见问题。"
        keywords="番木瓜漫画,关于番木瓜漫画,免费漫画平台,番木瓜漫画网,漫画大全,番木瓜漫画免费"
        canonicalUrl="https://www.fanmugua.com/about"
        schema={{ ...aboutSchema, ...faqSchema }}
      />
      <ScrollToTop />
      <Navbar />

      <main className="min-h-screen bg-background-50 pt-20">
        {/* Breadcrumb */}
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4">
          <nav className="flex items-center gap-1.5 text-xs text-foreground-500" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-600 transition-colors whitespace-nowrap">
              首页
            </Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-900 font-medium">关于我们</span>
          </nav>
        </div>

        {/* Hero */}
        <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-16">
          <div className="text-center max-w-3xl mx-auto">
            <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-6">
              <i className="ri-book-open-line text-3xl"></i>
            </div>
            <h1 className="font-heading font-black text-3xl md:text-4xl text-foreground-900 mb-6">
              关于番木瓜漫画
            </h1>
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed">
              番木瓜漫画是一个致力于为广大中文漫画爱好者提供<strong>免费全集阅读</strong>的在线漫画平台。
              我们相信，好的漫画应该被更多人看到，而价格不应该是障碍。
              番木瓜漫画网提供<strong>下拉式阅读</strong>方式，让您畅快体验<strong>番木瓜漫画免费全集</strong>的无限精彩。
            </p>
          </div>
        </section>

        {/* Brand Story */}
        <section className="py-14 md:py-20 bg-background-100 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
              <div>
                <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-6">
                  品牌故事
                </h2>
                <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    番木瓜漫画诞生于一个简单的想法：让所有人都能<strong>免费阅读高品质漫画</strong>。
                    创始团队是一群热爱漫画的年轻人，他们发现市面上很多漫画平台需要付费或会员才能阅读完整内容，
                    于是决定创建一个真正免费的漫画阅读平台——番木瓜漫画网。
                  </p>
                  <p>
                    经过数年的发展，番木瓜漫画已经成长为一个拥有海量漫画资源的<strong>漫画大全</strong>平台。
                    我们持续与优秀的内容创作者合作，确保番木瓜漫画的漫画库始终充满新鲜内容。
                    从热血战斗到甜蜜恋爱，从玄幻修仙到爆笑日常，番木瓜漫画<strong>免费全集</strong>应有尽有。
                  </p>
                  <p>
                    番木瓜漫画的<strong>下拉式阅读</strong>体验是我们引以为傲的特色。告别繁琐的翻页，
                    像刷社交媒体一样流畅地阅读漫画，带给你全新的沉浸式阅读感受。
                    番木瓜漫画网支持PC端和移动端，无论在哪里都能享受<strong>番木瓜漫画免费阅读</strong>的乐趣。
                  </p>
                </div>
              </div>
              <div className="relative">
                <div className="aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=warm%20and%20cozy%20reading%20nook%20with%20manga%20bookshelves%20and%20comfortable%20chair%2C%20soft%20natural%20light%20streaming%20through%20window%2C%20Japanese%20and%20Chinese%20aesthetic%20fusion%2C%20warm%20amber%20and%20cream%20tones%2C%20peaceful%20atmosphere%2C%20no%20people%2C%20zen%20vibe%2C%20clean%20composition%2C%20editorial%20photography%20style%2C%20high%20detail&width=800&height=600&seq=about-brand-01&orientation=landscape"
                    alt="番木瓜漫画品牌故事"
                    title="番木瓜漫画 - 品牌故事"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-14 md:py-20 bg-background-50 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div className="text-center p-6 rounded-lg bg-background-100">
                <div className="text-3xl md:text-4xl font-heading font-bold text-primary-500 mb-2">16+</div>
                <div className="text-sm text-foreground-500">漫画分类</div>
              </div>
              <div className="text-center p-6 rounded-lg bg-background-100">
                <div className="text-3xl md:text-4xl font-heading font-bold text-accent-500 mb-2">5000+</div>
                <div className="text-sm text-foreground-500">漫画作品</div>
              </div>
              <div className="text-center p-6 rounded-lg bg-background-100">
                <div className="text-3xl md:text-4xl font-heading font-bold text-primary-500 mb-2">10万+</div>
                <div className="text-sm text-foreground-500">漫画章节</div>
              </div>
              <div className="text-center p-6 rounded-lg bg-background-100">
                <div className="text-3xl md:text-4xl font-heading font-bold text-accent-500 mb-2">500万+</div>
                <div className="text-sm text-foreground-500">日活跃用户</div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-14 md:py-20 bg-background-100 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
                用户口碑
              </h2>
              <p className="text-foreground-500 text-sm mt-1">番木瓜漫画网用户真实评价</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {testimonials.map((t, idx) => (
                <div
                  key={idx}
                  className="p-5 rounded-lg bg-background-50 border border-background-200/70"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className={`${t.avatar} text-lg`}></i>
                    </div>
                    <div>
                      <div className="font-medium text-sm text-foreground-900">{t.name}</div>
                      <div className="text-xs text-foreground-500">{t.role}</div>
                    </div>
                    <div className="ml-auto flex items-center gap-0.5">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`text-xs ${i < t.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-300'}`}
                        ></i>
                      ))}
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{t.content}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-14 md:py-20 bg-background-50 px-4 md:px-6">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
                常见问题
              </h2>
              <p className="text-foreground-500 text-sm mt-1">关于番木瓜漫画的常见疑问</p>
            </div>
            <div className="space-y-3">
              <details className="group rounded-lg bg-background-100 border border-background-200/70">
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer font-medium text-sm text-foreground-900">
                  番木瓜漫画是否真的免费？
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  是的！番木瓜漫画所有漫画内容均免费提供，无需付费，无需会员，在线即可免费阅读全部漫画全集。番木瓜漫画网致力于为广大漫画爱好者提供优质的免费阅读体验。
                </div>
              </details>
              <details className="group rounded-lg bg-background-100 border border-background-200/70">
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer font-medium text-sm text-foreground-900">
                  番木瓜漫画支持什么阅读方式？
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  番木瓜漫画支持下拉式阅读，无需翻页，流畅滚动即可畅快阅读。同时支持PC端和移动端，随时随地享受番木瓜漫画免费全集的阅读乐趣。
                </div>
              </details>
              <details className="group rounded-lg bg-background-100 border border-background-200/70">
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer font-medium text-sm text-foreground-900">
                  番木瓜漫画有多少部作品？
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  番木瓜漫画网收录了海量热门漫画，涵盖热血、恋爱、玄幻、搞笑、悬疑、科幻、都市、古风等多种类型。番木瓜漫画持续更新中，每日都有新内容上线。
                </div>
              </details>
              <details className="group rounded-lg bg-background-100 border border-background-200/70">
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer font-medium text-sm text-foreground-900">
                  番木瓜漫画的更新频率如何？
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  番木瓜漫画每日更新，保持高频次的漫画更新节奏。热门连载漫画第一时间同步更新，确保读者能够及时追更。番木瓜漫画网始终与各大漫画平台保持同步。
                </div>
              </details>
              <details className="group rounded-lg bg-background-100 border border-background-200/70">
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer font-medium text-sm text-foreground-900">
                  如何在番木瓜漫画上找到想看的作品？
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  番木瓜漫画提供完善的分类系统，您可以通过分类导航快速找到喜欢的漫画类型。同时番木瓜漫画网首页展示了热门推荐和最新更新，方便您发现精彩作品。
                </div>
              </details>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section ref={contactRef} className="py-14 md:py-20 bg-background-100 px-4 md:px-6">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
                联系我们
              </h2>
              <p className="text-foreground-500 text-sm mt-1">番木瓜漫画网期待您的反馈</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
              <div className="text-center p-5 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-3">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">邮箱</div>
                <div className="text-sm font-medium text-foreground-900">contact@fanmugua.com</div>
              </div>
              <div className="text-center p-5 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3">
                  <i className="ri-customer-service-line text-lg"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">客服</div>
                <div className="text-sm font-medium text-foreground-900">在线客服 9:00-21:00</div>
              </div>
              <div className="text-center p-5 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mb-3">
                  <i className="ri-feedback-line text-lg"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">反馈</div>
                <div className="text-sm font-medium text-foreground-900">提交意见建议</div>
              </div>
            </div>

            <ContactForm />
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

function ContactForm() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypot && honeypot.value.trim() !== '') {
      alert('提交成功，感谢您的反馈！');
      form.reset();
      return;
    }

    try {
      const formData = new FormData(form);
      formData.delete('website_alt');
      const submitAddr = 'https://readdy.ai/api/form/d9oo87gsenbniolesiog';
      const response = await fetch(submitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      if (response.ok && parsed && (parsed as Record<string, string>).code === 'OK') {
        alert('提交成功！感谢您的反馈，番木瓜漫画团队会尽快回复您。');
        form.reset();
      } else {
        const msg = (parsed && (parsed as Record<string, string>).message) || '提交失败，请稍后再试。';
        alert(msg);
      }
    } catch {
      alert('网络错误，请稍后再试。');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4" data-readdy-form>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="contact_name" className="block text-xs text-foreground-600 mb-1.5">姓名</label>
          <input
            id="contact_name"
            name="name"
            type="text"
            required
            className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
            placeholder="请输入您的姓名"
          />
        </div>
        <div>
          <label htmlFor="contact_email" className="block text-xs text-foreground-600 mb-1.5">邮箱</label>
          <input
            id="contact_email"
            name="email"
            type="email"
            required
            className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
            placeholder="请输入您的邮箱"
          />
        </div>
      </div>
      <div>
        <label htmlFor="contact_subject" className="block text-xs text-foreground-600 mb-1.5">主题</label>
        <input
          id="contact_subject"
          name="subject"
          type="text"
          required
          className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
          placeholder="请输入主题"
        />
      </div>
      <div>
        <label htmlFor="contact_message" className="block text-xs text-foreground-600 mb-1.5">留言内容</label>
        <textarea
          id="contact_message"
          name="message"
          rows={4}
          required
          maxLength={500}
          className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
          placeholder="请输入您的留言内容（最多500字）"
        ></textarea>
        <p className="text-xs text-foreground-400 mt-1">最多500字</p>
      </div>
      <input name="website_alt" type="text" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
      <button
        type="submit"
        className="w-full px-6 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
      >
        提交反馈
      </button>
    </form>
  );
}